import { render, staticRenderFns } from "./DocAsyncApi.vue?vue&type=template&id=8b2ebd54&"
import script from "./DocAsyncApi.vue?vue&type=script&lang=js&"
export * from "./DocAsyncApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports